"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _BestLabel = _interopRequireDefault(require("../elements/BestLabel"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _RequiredInput = _interopRequireWildcard(require("./RequiredInput"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var RightLabel = _styledComponents["default"].span.withConfig({
  displayName: "RequiredInputWithLabel__RightLabel",
  componentId: "sc-1psompr-0"
})(["color:", ";font-weight:400;font-size:0.875rem;"], function (props) {
  return props.theme["mlb-red"];
});

var RequiredInputWithLabel = function RequiredInputWithLabel(_ref) {
  var validateFunc = _ref.validateFunc,
      rightLabel = _ref.rightLabel,
      children = _ref.children,
      label = _ref.label,
      requiredText = _ref.requiredText,
      name = _ref.name,
      className = _ref.className;
  return _react["default"].createElement("div", {
    className: className,
    id: "required-input-with-label"
  }, _react["default"].createElement("div", {
    className: "d-flex justify-content-between"
  }, _react["default"].createElement(_BestLabel["default"], {
    "for": name,
    required: true
  }, label), rightLabel ? _react["default"].createElement(RightLabel, null, " ", rightLabel, " ") : null), _react["default"].createElement(_RequiredInput["default"], {
    validateFunc: validateFunc,
    requiredText: requiredText
  }, children));
};

RequiredInputWithLabel.propTypes = {
  name: _propTypes["default"].string.isRequired,
  requiredText: _propTypes["default"].string,
  label: _propTypes["default"].any.isRequired,
  children: _propTypes["default"].object.isRequired,
  validateFunc: _propTypes["default"].func,
  rightLabel: _propTypes["default"].string,
  className: _propTypes["default"].string
};
RequiredInputWithLabel.defaultProps = {
  name: "",
  requiredText: null,
  label: "",
  className: "",
  rightLabel: "",
  children: {
    props: {}
  },
  validateFunc: _RequiredInput.validateFunc
};
var _default = RequiredInputWithLabel;
exports["default"] = _default;